import { memo } from "react";
import { useTheme } from "@mui/material/styles";
import ProjectLinkBox from "./ProjectLinkBox";
import UserQuestion from "./UserQuestion";
import KsbActionButton from "../../../components/KsbActionButton";
import { useAppContext } from "../../../context/appContext";
import { Login, PersonAdd, LockReset } from "@mui/icons-material";

function LeftInformation({ flipCard, loginPage, setOpenResetDialog }) {
  const theme = useTheme();
  const { isMobile } = useAppContext();

  const isLogin = loginPage;

  const userQuestionText = isLogin
    ? "Noch nicht registriert?"
    : "Bereits registriert?";

  // ✅ dynamic icon depending on state
  const switchIcon = isLogin ? <PersonAdd /> : <Login />;
  const switchLabel = isLogin ? "Registrieren" : "Zum Login";

  /* ----------------------------------------------------------------------- */
  /* ✅ MOBILE — compressed sidebar                                          */
  /* ----------------------------------------------------------------------- */

  if (isMobile) {
    return (
      <div
        style={{
          flex: "0 0 80px", // ✅ thin sidebar
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
          backgroundColor: theme.palette.primary.light,
          borderTopLeftRadius: "15px",
          borderBottomLeftRadius: "15px",
          padding: "0.5rem",
        }}
      >
        {/* ❗ keep question SHORT */}
        <div
          style={{ fontSize: "12px", fontWeight: "bold", textAlign: "center" }}
        >
          {isLogin ? "Neuer User?" : "Login?"}
        </div>

        {/* ✅ SWITCH */}
        <KsbActionButton onClick={flipCard} icon={switchIcon} size="small" />
        <br />
        <div
          style={{ fontSize: "12px", fontWeight: "bold", textAlign: "center" }}
        >
          PW vergessen?
        </div>

        {/* ✅ RESET */}
        <KsbActionButton
          onClick={() => setOpenResetDialog(true)}
          icon={<LockReset />}
          size="small"
        />
      </div>
    );
  }

  /* ----------------------------------------------------------------------- */
  /* ✅ DESKTOP — full panel                                                  */
  /* ----------------------------------------------------------------------- */

  return (
    <div
      style={{
        flex: 0.6,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.primary.light,
        borderTopLeftRadius: "15px",
        borderBottomLeftRadius: "15px",
        gap: "1em",
        padding: "1rem",
      }}
    >
      <UserQuestion text={userQuestionText} />

      <KsbActionButton
        onClick={flipCard}
        label={switchLabel}
        icon={switchIcon}
        variant="contained"
      />

      <ProjectLinkBox />

      <KsbActionButton
        onClick={() => setOpenResetDialog(true)}
        label="Passwort vergessen?"
        icon={<LockReset />}
        variant="contained"
      />
    </div>
  );
}

export default memo(LeftInformation);
